

export default function fromEntityStore(entity:any, key:string):any{
    const found = entity.store.find((x:EntityStore) => x.identityKey === key);
    return typeof found !== 'undefined' ? found.value : null
}
export const descriptionFromEntityStore = (entity:any, key:string):any =>{
    const found = entity.store.find((x:EntityStore) => x.identityKey === key);
    return typeof found !== 'undefined' ? found.description : null
}